import { CurrencyFormatter, CATEGORY_LIMIT } from "../chartHelper";
import { chartConfig } from "../chart.commonConfig";
import { PDF_CONSTANT } from "../../../../constant";
import { chartsLoadedAction } from "../../../../actions/reports.action";

export const FIRST_GRAPH_CHART_HELPER = data => {
  const BAR_CHART_CONFIG = {
    chart: {
      ...chartConfig.chart,
      zoomType: "xy",
      type: "column",
      className: "chart-background",
      spacingBottom: 50,
      height: 300,
      events: {
        load: () => {
          chartsLoadedAction({
            type: PDF_CONSTANT.SECOND_PAGE.THIRD._SUCCESS
          });
        }
      }
    },
    title: {
      ...chartConfig.title,
      text: ""
    },
    subtitle: {
      ...chartConfig.subtitle,
      y: 25,
      text: "",
      verticalAlign: "bottom"
    },
    xAxis: {
      visible: false
    },
    yAxis: {
      title: {
        text: ""
      },
      labels: {
        formatter: function() {
          return CurrencyFormatter(this.value / 100000).replace(/,/g, ".00");
        }
      },
      min: 0,
      max: 0
    },
    tooltip: {
      shared: false
    },
    legend: {
      enabled: true,
      verticalAlign: "middle",
      layout: "vertical",
      align: "right",
      floating: false
    },
    series: [],
    plotOptions: {
      animation: false,
      column: {
        dataLabels: {
          enabled: true,
          style: {
            textOutline: "none"
          },
          formatter: function() {
            return CurrencyFormatter(this.y / 100000).replace(/,/g, ".");
          }
        }
      },
      series: {
        groupPadding: 0,
        animation: false,
        events: {
          legendItemClick: function(event) {
            event.preventDefault();
          }
        }
      }
    },
    tooltip: {
      formatter: function() {
        return `
                <b>
                  ${this.key}
                </b><br />
                <b>Cost: ${CurrencyFormatter(this.y / 100000)} Lakh Cr</b>
              `;
      }
    }
  };

  try {
    // set data
    const { projectSectorDTOS: list = [], totalProjects = 0 } = data;
    let costArr = [],
      totalCost = 0;

    let othersCost = 0;
    list.forEach(({ sector, projectCost }, index) => {
      costArr.push(projectCost);
      totalCost += projectCost;
      if (index >= CATEGORY_LIMIT) {
        othersCost = othersCost + projectCost;
        BAR_CHART_CONFIG.series[CATEGORY_LIMIT] = {
          name: "Others",
          data: [{ name: "Others", y: othersCost }]
        };
      } else {
        BAR_CHART_CONFIG.series.push({
          name: sector,
          data: [{ name: sector, y: projectCost }]
        });
      }
    });

    BAR_CHART_CONFIG.yAxis.max = Math.max(...costArr) + 200000;
    BAR_CHART_CONFIG.title.text = `
            SECTOR INVESTMENT ${totalProjects} PROJECT : 
            INR ${(totalCost / 100000)
              .toString()
              .substr(0, 4)
              .replace(/,/g, ".")} LAKH CR.`;
    BAR_CHART_CONFIG.subtitle.text = `Sector wise break-up of ₹ ${(
      totalCost / 100000
    )
      .toString()
      .substr(
        0,
        4
      )} Lakh Cr. anticipated investment, for under construction / under implementation projects monitored by PMG`;
    return BAR_CHART_CONFIG;
  } catch (error) {
    console.error(error);
  }
};
